import { apiRouteUtils } from 'app/services/client/route-utils'
import { Environment } from 'app/app/api/config'
import { Args } from 'app/types/redux-types'
import { ThunkAPI } from '../../ReduxSlice'
import { Constants, environmentUrlMap } from 'app/app/(client)/utils/client-constants'
import { withThunkHandler } from 'app/app/(client)/utils/async-handler'
export interface BaseConfig {
  environment: Environment
  version: string
  apiBaseUrl: string
}

const getApiBaseUrlFromEnvironment = (environment: Environment): string =>
  environmentUrlMap.get(environment) || 'http://localhost:8080'

const fetchBaseConfig = async (_thunkAPI?: ThunkAPI, _args?: Args): Promise<BaseConfig> => {
  if (typeof window !== 'undefined') {
    const cachedConfig = sessionStorage.getItem(Constants.APP_CONFIG_KEY)
    if (cachedConfig) {
      const baseConfig = JSON.parse(cachedConfig) as BaseConfig
      setBaseConfigToWindowAndSession(baseConfig)
      return baseConfig
    } else {
      return await getBaseConfigFromRemote()
    }
  }
  return Promise.reject('Base config fetch failed')
}

export const getBaseConfig = withThunkHandler(fetchBaseConfig)

const setBaseConfigToWindowAndSession = (baseConfig: BaseConfig) => {
  Object.assign(window, { ...baseConfig })
  sessionStorage.setItem(Constants.APP_CONFIG_KEY, JSON.stringify(baseConfig))
}

const getBaseConfigFromRemote = async () => {
  const response = await fetch(apiRouteUtils.baseConfigUrl.url)
  if (!response.ok) {
    throw new Error(`Failed to fetch base config: ${response.statusText}`)
  }
  const { environment, version } = await response.json()
  const baseConfig: BaseConfig = { environment, version, apiBaseUrl: getApiBaseUrlFromEnvironment(environment) }
  setBaseConfigToWindowAndSession(baseConfig)
  return baseConfig
}
